import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "@ag-grid-community/angular";

@Component({
  selector: "app-actions-cell",
  template: `<div id="alarmRenderer">
    <div style= "height: '36px';

        overflow: 'hidden';
        'text-overflow': 'ellipsis';
        'margin-top': '2px'"

        [style.border-left]="colors ? '8px solid' + colors :  null"
 
    >
      <span style="padding-left: 10px;">{{ params.value }}</span>
    </div>
  </div>`,
  styles: [],
})
export class AlarmHistoryRendererComponent implements ICellRendererAngularComp {
  public params: any;
  public colors = "";
  agInit(params: any): void {
    let priority = "";
    this.colors = "";
    this.params = params;
    priority = this.params.data.Severity;
    if (priority == "Critical") {
      this.colors = "#E57373";
    } else if (priority == "Major") {
      this.colors = "#FFB74D";
    } else if (priority == "Minor") {
      this.colors = "#FFF176";
    }
  }
  refresh(): boolean {
    return false;
  }
}
